<template>
	<section>
		<template v-if="windowWidth >= mobileBreakpoint">
			<table class="table" style="margin-bottom: 10px">
				<thead>
					<tr>
						<th>Rachunki</th>
						<th class="text-right text-nowrap">Saldo PLN</th>
						<th>Typ</th>
						<th class="text-right">Numer NRB do wpłat</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(account, index) in paginatedAccounts"
						:key="account.login"
					>
						<template v-if="index == 0">
							<td>{{ account.login }}</td>
							<td class="text-right">
								<span class="ballance">{{
									$filters.currencyAlt(account.balance)
								}}</span>
							</td>
							<td>{{ account.type }}</td>
							<td class="text-right">
								<div class="text-truncate">
									{{ account.nrb }}
								</div>
							</td>
						</template>
						<template v-if="displayFormAccounts && index !== 0">
							<td>{{ account.login }}</td>
							<td class="text-right">
								<span class="ballance">{{
									$filters.currencyAlt(account.balance)
								}}</span>
							</td>
							<td>{{ account.type }}</td>
							<td class="text-right">
								<div class="text-truncate">
									{{ account.nrb }}
								</div>
							</td>
						</template>
					</tr>
				</tbody>
			</table>
		</template>
		<template v-else>
			<div
				v-for="account in paginatedAccounts"
				:key="account.login"
				class="clearfix account"
			>
				<div class="float-left">
					<p>{{ account.login }}</p>
					<p>
						<small>{{ account.nrb }}</small>
					</p>
				</div>
				<div class="float-right text-right">
					<strong class="account-amount">{{
						$filters.currencyAlt(account.balance)
					}}</strong>
				</div>
			</div>
		</template>
		<div
			v-if="
				currentUser &&
				currentUser.sso &&
				totalPages > 1 &&
				(displayFormAccounts || windowWidth < mobileBreakpoint)
			"
			class="pagination mb-3"
		>
			<button
				@click.prevent.stop="prevPage"
				:disabled="currentPage === 1"
				class="pagination-button"
			>
				<img
					src="images/chevron-left-green.svg"
					class="pagination-arrow"
				/>
			</button>
			<span class="pagination-info"
				>Strona {{ currentPage }} z {{ totalPages }}</span
			>
			<button
				@click.prevent.stop="nextPage"
				:disabled="currentPage === totalPages"
				class="pagination-button"
			>
				<img
					src="images/chevron-left-green.svg"
					class="pagination-arrow next"
				/>
			</button>
		</div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			currentPage: 1,
			accountsPerPage: 10,
		};
	},
	computed: {
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		...mapGetters({
			mobileBreakpoint: 'getMobileBreakpoing',
			currentUser: 'getCurrentUser',
		}),
		displayFormAccounts() {
			return this.$store.getters.getDisplayFormAccounts;
		},
		totalPages() {
			return Math.ceil(
				this.$store.getters.getAccountList.length / this.accountsPerPage
			);
		},
		paginatedAccounts() {
			if (this.currentUser && this.currentUser.sso) {
				const start = (this.currentPage - 1) * this.accountsPerPage;
				const end = start + this.accountsPerPage;
				const list = this.$store.getters.getAccountList;
				return list.slice(start, end);
			} else {
				return this.$store.getters.getAccountList
					? this.$store.getters.getAccountList
					: null;
			}
		},
	},
	mounted() {
		this.$store.dispatch('fetchAccountList');
	},
	methods: {
		nextPage() {
			if (this.currentPage < this.totalPages) {
				this.currentPage += 1;
			}
		},
		prevPage() {
			if (this.currentPage > 1) {
				this.currentPage -= 1;
			}
		},
	},
};
</script>
<style scoped>
.pagination {
	display: flex;
	align-items: center;
	justify-content: start;
	margin-bottom: 1rem;
}

.pagination-button {
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 3px; /* Slightly reduced border radius */
	padding: 0.3rem 0.6rem; /* Reduced padding */
	margin: 0 0.3rem; /* Reduced margin */
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: background-color 0.3s ease;
	outline: none;
}

.pagination-button:disabled {
	cursor: not-allowed;
	background-color: #f5f5f5;
	border-color: #e0e0e0;
	color: #ccc;
}

.pagination-button:disabled img {
	filter: grayscale(100%);
}

.pagination-button:not(:disabled):hover {
	background-color: #f0f0f0;
}

.pagination-arrow {
	margin-right: 4px; /* Reduced margin */
}

.pagination-arrow.next {
	transform: rotate(180deg);
}

.pagination-info {
	font-size: 0.9rem; /* Slightly reduced font size */
	color: #333;
}
</style>
